<template>
  <v-layout wrap>
    <v-flex xs12>
      <p class="mb-2">
        {{ $t('helps.reporters_data') }}
      </p>
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model.trim="corpo_name"
        v-validate="validationRules.get('corpoName')"
        class="required-field"
        :error-messages="errors.collect('corpoName')"
        :label="$t('label.corpo_name')"
        data-vv-name="corpoName"
        :data-vv-as="$t('label.corpo_name')"
        required
      />
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model.trim="corpo_street"
        v-validate="validationRules.get('street')"
        class="required-field"
        :error-messages="errors.collect('street')"
        :label="$t('label.street')"
        data-vv-name="street"
        :data-vv-as="$t('label.street')"
        required
      />
    </v-flex>
    <v-flex xs12>
      <v-layout justify-space-between>
        <v-flex
          lg5
          md5
          xs12
        >
          <v-text-field
            v-model.trim="corpo_building_number"
            v-validate="validationRules.get('building_number')"
            class="required-field"
            :error-messages="errors.collect('building_number')"
            :label="$t('label.building_number')"
            data-vv-name="building_number"
            :data-vv-as="$t('label.building_number')"
            required
          />
        </v-flex>
        <v-flex
          d-flex
          lg5
          md5
          xs12
        >
          <v-text-field
            v-model.trim="corpo_flat_number"
            v-validate="validationRules.get('flat_number')"
            :error-messages="errors.collect('flat_number')"
            :label="$t('label.flat_number')"
            data-vv-name="flat_number"
            :data-vv-as="$t('label.flat_number')"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-layout>
        <v-flex
          lg5
          md5
          xs12
          class="pr-md-4"
        >
          <v-text-field
            v-model="corpo_postal_code"
            v-validate="validationRules.get('postal_code')"
            class="required-field"
            mask="##-###"
            :error-messages="errors.collect('postal_code')"
            :label="$t('label.postal_code')"
            data-vv-name="postal_code"
            :data-vv-as="$t('label.postal_code')"
            required
            inputmode="numeric"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model.trim="corpo_city"
        v-validate="validationRules.get('city')"
        class="required-field"
        :error-messages="errors.collect('city')"
        :label="$t('label.city')"
        data-vv-name="city"
        :data-vv-as="$t('label.city')"
        required
      />
    </v-flex>
    <v-flex xs12>
      <v-autocomplete
        v-model="corpo_province"
        v-validate="validationRules.get('province')"
        :error-messages="errors.collect('province')"
        data-vv-name="province"
        :data-vv-as="$t('label.province')"
        :items="getProvinces"
        :search-input="provinceSearch"
        cache-items
        item-text="name"
        item-value="province_id"
        :label="$t('label.province')"
        class="required-field"
        append-icon="expand_more"
      />
    </v-flex>
    <v-flex xs12>
      <v-text-field
        v-model.trim="corpo_tax_id"
        v-validate="validationRules.get('nip')"
        class="required-field"
        :error-messages="errors.collect('nip')"
        :label="$t('label.nip')"
        data-vv-name="nip"
        :data-vv-as="$t('label.nip')"
        required
        mask="##########"
        inputmode="numeric"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import validationRules from '@/constants/validationRules';
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

export default {
    name: 'FamilyReporterCorporation',
    inject: ['$validator'],
    data: () => ({
        validationRules,
        provinceSearch: null
    }),
    computed: {
        ...mapFields('reporterData', [
            'reporterFormData.corpo_name',
            'reporterFormData.corpo_street',
            'reporterFormData.corpo_building_number',
            'reporterFormData.corpo_flat_number',
            'reporterFormData.corpo_postal_code',
            'reporterFormData.corpo_city',
            'reporterFormData.corpo_province',
            'reporterFormData.corpo_tax_id'
        ]),
        ...mapGetters('provinces', ['getProvinces'])
    }
};
</script>

<style scoped></style>
